import useSWR from '../../../../../node_modules/swr/core/dist/index.mjs';
import { organizationGetKey } from './organizationGetKey.mjs';
import { useStytchClient } from './useStytchClient.mjs';

const useOrgInfo = ()=>{
    const client = useStytchClient();
    const orgId = client.organization.getSync()?.organization_id;
    return useSWR(organizationGetKey(orgId), ()=>{
        return client.organization.get();
    });
};

export { useOrgInfo };
//# sourceMappingURL=useOrgInfo.mjs.map
